import { Stack, Text, Title } from "@mantine/core";
import { useMemo } from "react";
import {
  DictionaryManagement,
  DictionaryService,
} from "../../components/feature-specific/DictionaryManagement";
import {
  ConsolidateEducationFacultiesRequest,
  EducationFaculty,
  EducationFacultyCreateRequest,
  EducationFacultyUpdateRequest,
} from "../../models/education.model";
import { EducationDictionaryAdminService } from "../../services/admin";

export function EducationFacultyDictionary() {
  const educationService = useMemo(
    () => new EducationDictionaryAdminService(),
    []
  );

  // Adapt EducationDictionaryAdminService to DictionaryService interface for faculties
  const dictionaryService: DictionaryService<EducationFaculty> = useMemo(
    () => ({
      getDictionary: () => educationService.getEducationFaculties(),
      createItem: (item: Omit<EducationFaculty, "id">) =>
        educationService.createEducationFaculty({
          name: item.name,
        } as EducationFacultyCreateRequest),
      updateItem: (id: number, item: Partial<EducationFaculty>) =>
        educationService.updateEducationFaculty(id, {
          id,
          name: item.name!,
        } as EducationFacultyUpdateRequest),
      deleteItem: (id: number) => educationService.deleteEducationFaculty(id),
      consolidateItems: (sourceId: number, targetId: number) =>
        educationService.consolidateEducationFaculties({
          sourceFacultyId: sourceId,
          targetFacultyId: targetId,
        } as ConsolidateEducationFacultiesRequest),
    }),
    [educationService]
  );

  return (
    <Stack gap="md">
      <Stack gap="xs" mb="md">
        <Title order={3} size="h4" fw={600}>
          Education Faculties
        </Title>
        <Text c="dimmed">
          Manage faculties and departments within educational institutions
        </Text>
      </Stack>

      <DictionaryManagement
        title="Education Faculties"
        service={dictionaryService}
        itemDisplayName="Faculty"
        itemDisplayNamePlural="Faculties"
        canConsolidate={true}
        titleFieldName="name"
        searchPlaceholder="Search faculties..."
      />
    </Stack>
  );
}
